import { Button } from "@mui/material";
import { useTranslation } from "react-i18next";

interface MilestoneActionsProps {
  canRelease: boolean;
  canRemind: boolean;
  onReleasePayment: () => void;
  onSendReminder: () => void;
  isOwnershipLoading: boolean;
  isReleasePaymentPending: boolean;
  isMilestoneRemindPending: boolean;
}

export const MilestoneActions = ({
  canRelease,
  canRemind,
  onReleasePayment,
  onSendReminder,
  isOwnershipLoading,
  isReleasePaymentPending,
  isMilestoneRemindPending,
}: MilestoneActionsProps) => {
  const { t } = useTranslation("goService", { keyPrefix: "serviceRequestPage" });

  return (
    <>
      {canRelease && (
        <Button
          onClick={onReleasePayment}
          variant="primary-sm"
          disabled={isOwnershipLoading || isReleasePaymentPending}
          sx={styles.milestoneRemindButton}
        >
          {t("releasePayment")}
        </Button>
      )}
      {canRemind && (
        <Button
          onClick={onSendReminder}
          variant="primary-sm"
          disabled={isOwnershipLoading || isMilestoneRemindPending}
          sx={styles.milestoneRemindButton}
        >
          {t("milestoneRemind")}
        </Button>
      )}
    </>
  );
};

const styles = {
  milestoneRemindButton: {
    width: "fit-content",
  },
};
